module.exports = __webpack_public_path__ + "static/media/honeycombMap.5950ab2e.svg";